import { j as r } from "./atoms-v218.js";
import { CalendarList as l } from "./atoms-v2102.js";
import { CalendarPair as x } from "./atoms-v2103.js";
import { CalendarSingle as C } from "./atoms-v2104.js";
import { CalendarVariants as i } from "./atoms-v2105.js";
import { CalendarContextProvider as j } from "./atoms-v2106.js";
import { forwardRef as g } from "react";
function u({
  colorTheme: o = "light",
  config: n,
  dataSource: a,
  isLoading: m,
  onEmitNotification: e,
  onFetchNextData: s,
  onInternalError: f,
  onSelectionChange: p,
  variant: t
}, d) {
  return /* @__PURE__ */ r.jsxs(
    j,
    {
      config: n,
      dataSource: a,
      isLoading: m,
      onEmitNotification: e,
      onFetchNextData: s,
      onInternalError: f,
      onSelectionChange: p,
      ref: d,
      children: [
        t === i.list && /* @__PURE__ */ r.jsx(l, { colorTheme: o }),
        t === i.pair && /* @__PURE__ */ r.jsx(x, { colorTheme: o }),
        t === i.single && /* @__PURE__ */ r.jsx(C, { colorTheme: o })
      ]
    }
  );
}
const S = g(u);
export {
  S as Calendar,
  u as ComponentToForward
};
